<div class="generate-documents-form-container">
  <div class="title-container">
    <h3>{{ isCompanyRegistration ? 'Declaration' : 'Generate Documents' }}</h3>
  </div>

  @if (isTrustEstablishment) {
    <div class="declaration">
      <app-checkbox
        label="I declare that the information provided is true and correct"
        [boldLabel]="true"
        [(ngModel)]="declaration"
        (ngModelChange)="onDisableHeaderBtn()"
        [ngModelOptions]="{standalone: true}"
      />
    </div>
  } @else if (!loading) {
    <div class="form-body-container" [formGroup]="form">
      @if (!isCompanyRegistration) {
        @if (documentTypeOptions.length) {
          <div class="document-type">
            <app-radio
              label="Choose the type of document to generate"
              [options]="documentTypeOptions"
              [(ngModel)]="formModel.documentationType"
              (ngModelChange)="onDocumentationTypeChange()"
              (select)="onDocumentTypeSelectionChange()"
              [ngModelOptions]="{standalone: true}"
            />
          </div>
        }

        @if (formModel.documentationType === DocumentationTypeEnum.Minutes) {
          <div class="d-flex gap-24">
            <div class="meeting-date">
              <app-date-picker
                label="Date Meeting was Held"
                [minDate]="minDateOfMeeting"
                [maxDate]="maxDateOfMeeting"
                [customErrors]="customDatepickerErrors"
                [(ngModel)]="formModel.meetingDate"
                (ngModelChange)="onDisableHeaderBtn()"
                [ngModelOptions]="{standalone: true}"
              />
            </div>

            <div class="meeting-type">
              <app-select
                label="Type"
                placeholder="Select type"
                [valuePrimitive]="true"
                [options]="meetingTypeOptions"
                [(ngModel)]="formModel.meetingAddressType"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onMeetingAddressTypeSelect($event)"
              />
            </div>
          </div>

          @if (formModel.meetingAddressType === MeetingLocationTypeEnum.Online) {
            <div class="meeting-address">
              <app-select
                label="Communication Method"
                placeholder="Select Communication Method"
                [valuePrimitive]="true"
                [options]="meetingOnlineTypeOptions"
                [(ngModel)]="formModel.meetingOnlineAddress"
                (ngModelChange)="onDisableHeaderBtn()"
                [ngModelOptions]="{standalone: true}"
              />
            </div>
          }

          @if (formModel.meetingAddressType !== undefined && formModel.meetingAddressType !== MeetingLocationTypeEnum.Online && formModel.meetingAddressType !== MeetingLocationTypeEnum.Phone) {
            <div class="address" [formGroup]="form">
              <app-address-form-group
                [formGroup]="form.controls.address"
                [label]="MeetingLocationTypeEnum[formModel.meetingAddressType] + ' Address'"
                [expandedAddressForm]="expandedAddressForm"
                [addressStatus]="addressStatus"
                [isDisabled]="formModel.meetingAddressType !== MeetingLocationTypeEnum.Other"
                (onDataStatusChange)="onDataStatusChange($event)"
              />
            </div>
          }

          @if (getOfficeholdersByType([RelationshipType.Director]).length) {
            <div class="attendees">
              <app-list-grid-client-side
                [rowData]="attendeesList"
                [colDefs]="$any(colDefs)"
                [rowSelection]="attendeesRowSelection"
                [pagination]="false"
                [paginationPageSizeSelector]="false"
                (gridReady)="onGridReady($event)"
              />
            </div>

            @if (formModel.chairperson) {
              <div class="chair">
                <app-select
                  label="Chairperson"
                  placeholder="Select Chairperson"
                  [valuePrimitive]="true"
                  [options]="chairOptions"
                  [(ngModel)]="formModel.chairperson.relationshipId"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onChairPersonSelect($event)"
                  required
                />
              </div>
            }
          }

          @if (documentTypeIs362 || (document.entityId === null && documentTypeIs484)) {
            <app-multiple-name-input
              formControlName="directorNameList"
              label="Name of the Directors who attended the meeting"
              [tip]="'Separate names of directors with semicolon'"
              [customErrors]="directorNameListCustomErrors"
            />
          }
        }

        <div class="d-flex gap-24">
          @if (!(documentTypeIs361 || isRaForm || documentTypeIs370 || (document.entityId === null && documentTypeIs362))) {
            <div class="authorising-officeholder">
              <app-select
                label="Authorising Officeholder"
                placeholder="Select auth officeholder"
                [valuePrimitive]="true"
                [options]="authorisingOfficeholdersOptions"
                [(ngModel)]="formModel.authorisingParty.relationshipId"
                (ngModelChange)="onDisableHeaderBtn()"
                [ngModelOptions]="{standalone: true}"
                required
              />
            </div>
          }

          @if (!company.officers.length && documentTypeIs362) {
            <div class="authorising-officeholder">
              <app-integrations-entity-search-control
                formControlName="directorName"
                label="Authorising Officeholder"
                placeholder="Enter authorising officeholder"
                [entityType]="authorisingOfficeholderEntitySearchEntityType"
                [customErrors]="directorFullNameValidatorMsg"
              />
            </div>
          }

          <div class="signing-manager">
            <app-select
              label="Contact Name"
              placeholder="Select contact name"
              [valuePrimitive]="true"
              [options]="contactNameOptions"
              [(ngModel)]="formModel.signingManager"
              (ngModelChange)="onDisableHeaderBtn()"
              [ngModelOptions]="{standalone: true}"
              required
            />
          </div>
        </div>

        @if (!company.officers.length && documentTypeIs362) {
          <div class="d-flex gap-24">
            <div class="phone">
              <app-input-phone-number
                formControlName="phone"
                label="Authorising Officeholder Phone Number"
                placeholder="Enter phone number"
              />
            </div>

            <div class="email">
              <app-input
                formControlName="email"
                label="Authorising Officeholder Email Address"
                placeholder="Enter email address"
                [customErrors]="emailValidatorMsg"
              />
            </div>
          </div>
        }

        @if (directorOptions.length && formModel.directorReplacedByAlternative) {
          <div class="director">
            <app-select
              label="Director for alternative"
              placeholder="Select director"
              [valuePrimitive]="true"
              [options]="directorOptions"
              [(ngModel)]="formModel.directorReplacedByAlternative.relationshipId"
              (ngModelChange)="onDisableHeaderBtn()"
              [ngModelOptions]="{standalone: true}"
            />
          </div>
        }

        @if (documentTypeIs361 || isRaForm) {
          <div class="declaration">
            <app-checkbox
              label="I declare the agent is authorised to give notice"
              [boldLabel]="true"
              [(ngModel)]="authAgentDeclaration"
              (ngModelChange)="onDisableHeaderBtn()"
              [ngModelOptions]="{standalone: true}"
            />
          </div>
        }

        @if (documentSelection && documentSelection.length > 1) {
          <app-document-selection
            title="Choose Documents to Generate"
            [documentSelectionList]="documentSelection"
            [documentationType]="formModel.documentationType"
            (documentSelectionChange)="onDocumentSelectionChange($event)"
          />
        }
      }

      @if (isCompanyRegistration) {
        <app-checkbox
          [label]="companyRegistrationDeclarationLabel"
          [formControl]="companyRegistrationDeclarationAssentCheckbox"
          (change)="onDisableHeaderBtn()"
        />

        @if (isSpecialPurposeCompanyRegistration) {
          <div [innerHtml]="specialPurposeCompanyDeclaration"></div>
        } @else {
          <div [innerHtml]="standardCompanyDeclaration"></div>
        }
        <div class="declaration">
          <app-checkbox
            label="I hereby declare that all information provided in this interview form is true and correct."
            [boldLabel]="true"
            [(ngModel)]="declaration"
            (ngModelChange)="onDisableHeaderBtn()"
            (change)="declarationSelect($event)"
            [ngModelOptions]="{standalone: true}"
          />
        </div>
      } @else {
        <div class="declaration">
          <app-checkbox
            label="I declare that the information provided is true and correct"
            [boldLabel]="true"
            [(ngModel)]="declaration"
            (ngModelChange)="onDisableHeaderBtn()"
            (change)="declarationSelect($event)"
            [ngModelOptions]="{standalone: true}"
          />
        </div>
      }
    </div>
  } @else {
    <div class="skeleton-container">
      <ngx-skeleton-loader count="2" appearance="line"/>
      <div class="d-flex gap-24">
        <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
        <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
      </div>
      <ngx-skeleton-loader count="2" appearance="line"/>
      <div class="d-flex gap-24">
        <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
        <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
      </div>
      <ngx-skeleton-loader count="2" appearance="line"/>
    </div>
  }
</div>
